exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "fi-choose-internal {\n  display: block;\n  max-width: 602px;\n}", ""]);

// exports
